import { type yup } from '@framework/validation/initYup.ts';
import { checkNever } from '../../../../../../utils/checkNever.ts';
import { type PaymentRowFieldKey } from '../createPaymentRowFormSchema.ts';

/**
 * Switch che ritorna la label di un campo in base al field indicato.
 */
function getFieldLabel(fieldCode: PaymentRowFieldKey) {
  switch (fieldCode) {
    case 'baseUnitAmount':
      return `Importo unitario di listino`;
    case 'description':
      return `Descrizione`;
    case 'quantity':
      return `Quantità`;
    case 'unit':
      return `Unità di misura`;
    case 'vat':
      return `Percentuale IVA`;
    case 'discount':
      return `Sconto/Esenzione`;
    case 'included':
      return `Incluso nel pagamento`;

    case 'totalAmount':
      return 'Totale';
    case 'totalNoDiscountAmount':
      return `Totale senza sconto`;
    case 'unitAmount':
      return `Importo unitario`;
    case 'taxableAmount':
      return `Imponibile`;
    case 'vatAmount':
      return `Imponibile IVA`;

    default:
      // controlla che lo switch sia esaustivo ma non lancia eccezioni
      checkNever(fieldCode);
      return '<unknown>';
  }
}

/**
 * Funzione che cicla sulla struttura del validatore delle voci di costo per impostare
 * in automatico le label di ogni campo.
 */
export function setPaymentFieldSchemaLabel(
  schemaObject: Record<string, yup.AnySchema>,
  widgetLabel: string | null | undefined,
) {
  // Recuperiamo le chiavi
  const keys = Object.keys(schemaObject);

  keys.forEach(key => {
    // Recuperiamo il codice del campo (la key è composta da "<widgetCode>@<fieldCode>"")
    const [_, fieldCode] = key.split('@');

    // Se nessun fieldCode è presente, mostriamo solo il widgetLabel,
    // altrimenti mostriamo anche la descrizione del campo
    const fieldLabel = !fieldCode
      ? ''
      : `: ${getFieldLabel(fieldCode as PaymentRowFieldKey)}`;

    schemaObject[key] = schemaObject[key].label(`${widgetLabel}${fieldLabel}`);
  });
}
